import React from 'react';
import PriceWithCurrency from './PriceWithCurrency';
import siteMetadata from '../siteMetadata';

const PricePill = ({ prices, lang, className }) => {
  return (
    <div className={`px-4 flex justify-center items-center ${className}`}>
      <div className="bg-light-500 text-white flex font-serifdisplay rounded-full px-4 leading-7 lg:px-6">
        <span className="mr-1 text-sm capitalize">{lang === siteMetadata.defaultLang ? 'from' : 'desde'}</span>
        <PriceWithCurrency prices={prices} className="text-base" />
      </div>
    </div>
  );
};

export default PricePill;
